/* Formaë — Motion v3 (DA Core Atelier, 2026-09-13)
   GSAP 3.15 + ScrollTrigger + SplitText + Lenis, tous vendorisés dans assets/.
   Sans lib, sans JS ou en mouvement réduit : le contenu reste visible. */
(function () {
  'use strict';
  var W = window, D = document;
  var hasGsap = !!(W.gsap && W.ScrollTrigger);
  var REDUCED = !!(W.matchMedia && W.matchMedia('(prefers-reduced-motion: reduce)').matches);
  if (hasGsap) {
    W.gsap.registerPlugin(W.ScrollTrigger);
    if (W.SplitText) W.gsap.registerPlugin(W.SplitText);
  }

  /* ── Utilitaires ─────────────────────────────── */
  function isProductTemplate() {
    var m = D.querySelector('main[data-template]');
    return !!m && /^product/.test(m.dataset.template || '');
  }
  function startFor(desktop, mobile) { return W.innerWidth < 1024 ? mobile : desktop; }

  /* Périmètre des passes génériques : la home et le footer v3, rien d'autre. Même
     périmètre que les états initiaux de formae-v3.css. Ailleurs (page contact, page
     produit…), le reveal historique .f-revealed de formae-custom.js reste maître et
     le moteur n'écrit aucune valeur inline. */
  var V3_SCOPE = 'main[data-template="index"], .f3-footer';
  function inScope(el) { return !!el.closest(V3_SCOPE); }

  /* Ordre « depuis le milieu » : [milieu, milieu+1, milieu-1, milieu+2, ...] (recette Core Atelier). */
  function orderFromCenter(items) {
    var arr = Array.prototype.slice.call(items || []);
    if (arr.length < 3) return arr;
    var mid = Math.floor(arr.length / 2), out = [arr[mid]];
    for (var i = 1; i <= mid; i++) {
      if (arr[mid + i]) out.push(arr[mid + i]);
      if (arr[mid - i]) out.push(arr[mid - i]);
    }
    return out;
  }

  /* Repli : tout visible (pas de lib, mouvement réduit). */
  function showAll(root) {
    var scope = root || D;
    scope.querySelectorAll('[data-reveal]').forEach(function (el) {
      if (inScope(el)) { el.style.opacity = '1'; el.style.transform = 'none'; }
    });
    scope.querySelectorAll('.f3-cover').forEach(function (c) { if (inScope(c)) c.style.display = 'none'; });
    scope.querySelectorAll('[data-f3-fade]').forEach(function (el) { if (inScope(el)) el.style.opacity = '1'; });
    /* Le hero n'a ni [data-reveal] ni .f3-cover : ses états initiaux sont posés par classe,
       il faut donc les lever explicitement, sinon il reste invisible sans GSAP. */
    scope.querySelectorAll('.formae-hero-video__title').forEach(function (t) { if (inScope(t)) t.classList.add('is-ready'); });
    scope.querySelectorAll('.formae-hero-video__subtitle, .formae-hero-video__ctas, .formae-hero-video__proof').forEach(function (el) { if (inScope(el)) el.style.opacity = '1'; });
    scope.querySelectorAll('.formae-hero-video__media').forEach(function (m) { if (inScope(m)) m.style.transform = 'none'; });
    /* Le titre du manifeste part à scale(--heading-scale) par CSS : sans GSAP il faut le
       ramener à 1, sinon il déborde sur la grille. */
    scope.querySelectorAll('.formae-manifesto__title').forEach(function (t) { if (inScope(t)) t.style.transform = 'none'; });
  }

  /* Lettres qui montent depuis le milieu de chaque ligne (SplitText, lignes masquées). */
  function riseChars(target, opts) {
    if (!W.SplitText || !hasGsap) return null;
    var o = Object.assign({ duration: .75, stagger: .04, ease: 'power1.out', delay: 0, onDone: null }, opts || {});
    return W.SplitText.create(target, {
      type: 'lines,words,chars',
      mask: 'lines',
      autoSplit: true,
      aria: 'auto',
      onSplit: function (self) {
        /* Les masques de ligne rognent les jambages (p de « pensé ») : la boîte de clip
           descend de .25em, compensée par une marge négative, sans décaler la mise en page. */
        (self.masks || []).forEach(function (m) { m.style.paddingBottom = '.25em'; m.style.marginBottom = '-.25em'; });
        var tl = W.gsap.timeline({ delay: o.delay });
        self.lines.forEach(function (line) {
          var chars = self.chars.filter(function (c) { return line.contains(c); });
          tl.from(orderFromCenter(chars), { yPercent: 105, duration: o.duration, stagger: o.stagger, ease: o.ease }, 0);
        });
        if (o.onDone) tl.eventCallback('onComplete', o.onDone);
        return tl;
      }
    });
  }

  /* ── Reveals génériques ──────────────────────── */
  var REVEAL_FROM = { y: 50, opacity: 0 };
  var REVEAL_TO = { y: 0, opacity: 1, duration: .8, ease: 'power2.out', delay: .1 };

  function initReveals(root) {
    var scope = root || D;
    var all = Array.prototype.slice.call(scope.querySelectorAll('[data-reveal]'));
    var singles = all.filter(function (el) {
      return !el.__f3 && el.getAttribute('data-reveal') !== 'curtain' && !el.closest('[data-reveal-group]') && inScope(el);
    });
    singles.forEach(function (el) {
      el.__f3 = true;
      W.gsap.fromTo(el, Object.assign({}, REVEAL_FROM), Object.assign({}, REVEAL_TO, {
        scrollTrigger: { trigger: el, start: startFor('top 90%', 'top 92%'), once: true }
      }));
    });
    scope.querySelectorAll('[data-reveal-group]').forEach(function (group) {
      if (group.__f3 || !inScope(group)) return;
      group.__f3 = true;
      var kids = Array.prototype.slice.call(group.querySelectorAll('[data-reveal]'));
      kids.forEach(function (k) { k.__f3 = true; });
      W.gsap.set(kids, Object.assign({}, REVEAL_FROM));
      W.ScrollTrigger.batch(kids, {
        start: startFor('top 90%', 'top 92%'),
        once: true,
        onEnter: function (batch) { W.gsap.to(batch, Object.assign({}, REVEAL_TO, { stagger: .1 })); }
      });
    });
  }

  function initCurtains(root) {
    var scope = root || D;
    scope.querySelectorAll('[data-reveal="curtain"]').forEach(function (el) {
      if (el.__f3 || !inScope(el)) return;
      el.__f3 = true;
      var cover = el.querySelector('.f3-cover');
      if (!cover) return;
      W.ScrollTrigger.create({
        trigger: el,
        start: startFor('top 80%', 'top 90%'),
        once: true,
        onEnter: function () {
          W.gsap.to(cover, { yPercent: 100, duration: .8, ease: 'power2.out', onComplete: function () { cover.style.display = 'none'; } });
          el.querySelectorAll('[data-f3-fade]').forEach(function (t, i) {
            W.gsap.to(t, { opacity: 1, duration: .5, delay: .1 * i });
          });
        }
      });
    });
  }

  /* ── Lenis (smooth scroll) ───────────────────── */
  function initLenis() {
    if (REDUCED || !W.Lenis || !hasGsap || isProductTemplate() || W.__f3Lenis) return null;
    var lenis = new W.Lenis({ autoRaf: true, lerp: .1 });
    lenis.on('scroll', W.ScrollTrigger.update);
    W.__f3Lenis = lenis;
    return lenis;
  }

  /* ── Registre des sections ───────────────────── */
  var registry = [];
  function register(selector, fn) { registry.push({ selector: selector, fn: fn }); }

  /* Registre « toujours actif » : ces sections tournent aussi sans GSAP et en mouvement
     réduit, avec un repli sans animation. Leur fonction reçoit { animated } pour choisir
     son mode. Une commande qui ne masque rien (le slider d'avis) doit rester utilisable
     partout, sinon le contenu devient inatteignable au lieu d'être seulement immobile. */
  var alwaysRegistry = [];
  function registerAlways(selector, fn) { alwaysRegistry.push({ selector: selector, fn: fn }); }
  function runRegistry(list, root, name) {
    list.forEach(function (entry, index) {
      var nodes = root.matches && root.matches(entry.selector) ? [root] : Array.prototype.slice.call(root.querySelectorAll(entry.selector));
      nodes.forEach(function (el) {
        var key = '__f3init_' + name + '_' + index;
        if (el[key]) return;
        el[key] = true;
        entry.fn(el, { animated: hasGsap && !REDUCED });
      });
    });
  }

  function init(root) {
    root = root || D;
    runRegistry(alwaysRegistry, root, 'always');
    if (!hasGsap || REDUCED) { showAll(root); return; }
    initReveals(root);
    initCurtains(root);
    runRegistry(registry, root, 'motion');
    W.ScrollTrigger.refresh();
  }
  function refresh() { if (hasGsap) W.ScrollTrigger.refresh(); }

  /* == SECTIONS == */
  /* Les blocs des sections (hero, manifeste, bande image, avis, footer) sont insérés ici par les tâches 4 à 9. */

  /* ── HERO : zoom arrière 10 s, lettres depuis le milieu, fondus, preuves tournantes ── */
  register('.formae-hero-video', function (el) {
    var title = el.querySelector('.formae-hero-video__title');
    var media = el.querySelector('.formae-hero-video__media');
    var fades = ['.formae-hero-video__subtitle', '.formae-hero-video__ctas', '.formae-hero-video__proof']
      .map(function (s) { return el.querySelector(s); }).filter(Boolean);
    if (media) W.gsap.to(media, { scale: 1, duration: 10, ease: 'power1.out' });

    function reveal() { if (fades.length) W.gsap.to(fades, { opacity: 1, duration: .8, stagger: .2, delay: 1.4 }); }
    function run() {
      if (title) {
        title.classList.add('is-ready');
        if (!riseChars(title)) W.gsap.set(title, { opacity: 1 });
      }
      reveal();
    }
    if (D.fonts && D.fonts.ready) D.fonts.ready.then(run); else run();

    var items = Array.prototype.slice.call(el.querySelectorAll('.formae-hero-video__proof-item'));
    if (items.length > 1) {
      var idx = 0;
      /* y: 0 neutralise le translateY(200%) du CSS de repli, sinon GSAP l'empile
         avec yPercent et la preuve entrante reste sous la ligne. */
      W.gsap.set(items.slice(1), { yPercent: 200, y: 0 });
      var next = function () {
        var cur = items[idx], nxt = items[(idx + 1) % items.length];
        W.gsap.timeline({ onComplete: function () { idx = (idx + 1) % items.length; W.gsap.delayedCall(2.5, next); } })
          .to(cur, { yPercent: -200, duration: .6, ease: 'power4.in' })
          .fromTo(nxt, { yPercent: 200 }, { yPercent: 0, duration: .6, ease: 'power1.out' }, '-=0.2');
      };
      W.gsap.delayedCall(3, next);
    }
  });

  /* ── MANIFESTE : titre scale → 1 au scroll (desktop), image y 60 → 0 (scrub 2), fondus avec le rideau ── */
  register('.formae-manifesto', function (el) {
    /* Hors du périmètre v3, les états initiaux CSS ne s'appliquent pas : la section est
       déjà lisible, on n'anime rien pour ne pas la masquer. */
    if (!inScope(el)) return;
    var title = el.querySelector('.formae-manifesto__title');
    var text = el.querySelector('.formae-manifesto__text');
    var imageWrap = el.querySelector('.formae-manifesto__image-wrap');
    var fades = [title, text].filter(Boolean);
    var startScale = parseFloat(getComputedStyle(el).getPropertyValue('--heading-scale')) || 1.6;
    var mm = W.gsap.matchMedia();
    mm.add('(min-width: 1024px)', function () {
      if (title) {
        W.gsap.fromTo(title, { scale: startScale, transformOrigin: 'top left' }, {
          scale: 1, ease: 'power1.out',
          scrollTrigger: { trigger: el, start: 'top-=20% 50%', end: 'top+=50% 50%', scrub: true }
        });
      }
      if (imageWrap) {
        W.gsap.fromTo(imageWrap, { y: 60 }, {
          y: 0, ease: 'power1.out',
          scrollTrigger: { trigger: el, start: 'top+=15% 80%', end: 'top+=60% 80%', scrub: 2 }
        });
      }
    });
    mm.add('(max-width: 1023px)', function () {
      if (title) W.gsap.set(title, { clearProps: 'transform' });
    });
    W.ScrollTrigger.create({
      trigger: imageWrap || title || el,
      start: startFor('top 80%', 'top 90%'),
      once: true,
      onEnter: function () { W.gsap.to(fades, { opacity: 1, duration: .5, stagger: .1, delay: imageWrap ? .3 : 0 }); }
    });
  });

  /* ── BANDE IMAGE : parallaxe -8 % → 8 % sur toute la traversée ── */
  register('.formae-image-band', function (el) {
    var img = el.querySelector('.formae-image-band__img');
    if (!img) return;
    W.gsap.fromTo(img, { yPercent: -8 }, {
      yPercent: 8, ease: 'none',
      scrollTrigger: { trigger: el, start: 'top bottom', end: 'bottom top', scrub: true }
    });
  });

  /* ── AVIS : piste en boucle (clones aux extrémités), flèches, swipe, clavier, autoplay ──
     Registre « toujours actif » : le slider ne masque rien, il doit rester navigable même
     sans GSAP et en mouvement réduit. Dans ce repli, pas de clone ni de tween : la boucle
     se fait par modulo et le transform est posé directement. */
  registerAlways('.formae-reflections', function (el, mode) {
    var track = el.querySelector('.formae-reflections__track');
    var slides = Array.prototype.slice.call(el.querySelectorAll('.formae-reflections__slide'));
    var counter = el.querySelector('[data-current]');
    var vp = el.querySelector('.formae-reflections__viewport');
    var n = slides.length;
    if (!track || !vp || n < 2) return;

    var animated = !!(mode && mode.animated);
    /* Animé : pos 1 = 1re vraie slide (après le clone du dernier). Repli : pos 0..n-1. */
    var pos = animated ? 1 : 0;
    var go;

    /* Compteur et aria-hidden : même sortie dans les deux modes. */
    function render() {
      var real = animated ? ((pos - 1) % n + n) % n : (pos % n + n) % n;
      if (counter) counter.textContent = String(real + 1);
      slides.forEach(function (s, i) { s.setAttribute('aria-hidden', i === real ? 'false' : 'true'); });
    }

    if (animated) {
      var cloneLast = slides[n - 1].cloneNode(true), cloneFirst = slides[0].cloneNode(true);
      [cloneLast, cloneFirst].forEach(function (c) {
        c.classList.add('is-clone'); c.setAttribute('aria-hidden', 'true'); c.removeAttribute('data-shopify-editor-block');
      });
      track.insertBefore(cloneLast, slides[0]);
      track.appendChild(cloneFirst);
      W.gsap.set(track, { xPercent: -100 });
      var busy = false;
      go = function (dir) {
        if (busy) return;
        busy = true; pos += dir; render();
        W.gsap.to(track, { xPercent: -100 * pos, duration: 1, ease: 'power2.inOut', onComplete: function () {
          if (pos === n + 1) { pos = 1; W.gsap.set(track, { xPercent: -100 }); }
          if (pos === 0) { pos = n; W.gsap.set(track, { xPercent: -100 * n }); }
          busy = false; render();
        } });
      };
    } else {
      go = function (dir) {
        pos = (pos + dir) % n;
        if (pos < 0) pos += n;
        track.style.transform = 'translateX(' + (-100 * pos) + '%)';
        render();
      };
    }

    var prev = el.querySelector('[data-prev]'), next = el.querySelector('[data-next]');
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });

    var x0 = null;
    vp.addEventListener('pointerdown', function (e) { x0 = e.clientX; });
    vp.addEventListener('pointerup', function (e) {
      if (x0 === null) return;
      var dx = e.clientX - x0; x0 = null;
      if (Math.abs(dx) > 40) go(dx < 0 ? 1 : -1);
    });
    vp.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
    });

    /* Autoplay en mode animé seulement : en mouvement réduit, rien ne défile tout seul. */
    var every = animated ? (parseFloat(el.dataset.autoplay) || 0) : 0, timer = null;
    function stop() { if (timer) clearInterval(timer); timer = null; }
    function start() { stop(); timer = setInterval(function () { go(1); }, every * 1000); }
    if (every > 0) {
      start();
      /* Pause aussi au focus clavier : sinon la slide change sous les doigts de qui
         navigue à la tabulation. */
      el.addEventListener('pointerenter', stop); el.addEventListener('focusin', stop);
      el.addEventListener('pointerleave', start); el.addEventListener('focusout', start);
    }
    render();
  });

  /* ── FOOTER : wordmark géant, lettres depuis le milieu à l'arrivée ── */
  register('.f3-footer', function (el) {
    var wrap = el.querySelector('.f3-footer__jumbo-wrap');
    var jumbo = el.querySelector('.f3-footer__jumbo');
    var img = el.querySelector('.f3-footer__jumbo-img');
    if (!wrap || !(jumbo || img)) return;
    function play() {
      if (jumbo && W.SplitText) {
        var split = W.SplitText.create(jumbo, { type: 'chars', aria: 'auto' });
        W.gsap.from(orderFromCenter(split.chars), {
          yPercent: 105, duration: .75, ease: 'power1.in', stagger: .075,
          scrollTrigger: { trigger: wrap, start: 'center bottom', once: true }
        });
      } else {
        W.gsap.from(jumbo || img, { yPercent: 105, duration: .9, ease: 'power1.out', scrollTrigger: { trigger: wrap, start: 'center bottom', once: true } });
      }
    }
    if (D.fonts && D.fonts.ready) D.fonts.ready.then(play); else play();
  });

  /* == BOOT == */
  function boot() {
    initLenis();
    init(D);
    W.addEventListener('load', refresh);
  }
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', boot); else boot();
  D.addEventListener('shopify:section:load', function (e) { init(e.target); });
  D.addEventListener('shopify:section:reorder', refresh);

  W.FormaeMotion = {
    init: init, refresh: refresh, register: register, registerAlways: registerAlways, initLenis: initLenis,
    orderFromCenter: orderFromCenter, riseChars: riseChars, startFor: startFor, reduced: REDUCED
  };
})();
